import { forwardRef } from 'react';
import { AppTextField } from './AppTextField';
import type { TextFieldProps } from '@mui/material';

type AppDateFieldProps = Omit<TextFieldProps, 'type' | 'variant'>;

export const AppDateField = forwardRef<HTMLInputElement, AppDateFieldProps>(({ ...props }, ref) => {
  return (
    <AppTextField
      ref={ref}
      type="date"
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  );
});

AppDateField.displayName = 'AppDateField';

// Time field variant
type AppTimeFieldProps = Omit<TextFieldProps, 'type' | 'variant'>;

export const AppTimeField = forwardRef<HTMLInputElement, AppTimeFieldProps>(({ ...props }, ref) => {
  return (
    <AppTextField
      ref={ref}
      type="time"
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  );
});

AppTimeField.displayName = 'AppTimeField';

// DateTime field variant
type AppDateTimeFieldProps = Omit<TextFieldProps, 'type' | 'variant'>;

export const AppDateTimeField = forwardRef<HTMLInputElement, AppDateTimeFieldProps>(
  ({ ...props }, ref) => {
    return (
      <AppTextField
        ref={ref}
        type="datetime-local"
        InputLabelProps={{
          shrink: true,
        }}
        {...props}
      />
    );
  }
);

AppDateTimeField.displayName = 'AppDateTimeField';
